import { useState } from 'react';
/**
 * 非同期のactionをdispatchする
 * @param dispatch
 * @param action
 */
export const wrapDispatch = (dispatch, action) => new Promise((resolve, reject) => {
    dispatch(Object.assign(Object.assign({}, action), { meta: Object.assign(Object.assign({}, action.meta), { reject,
            resolve }) }));
});
export const useWrapDispatchState = (initialState) => useState(initialState);
